import axios from 'axios';
import { BASE_URL } from './constants';

const defaultInstance = axios.create({
    baseURL: BASE_URL,
});

export default defaultInstance;